import { FormattedMessage } from 'react-intl'

export const COMMUNITY_HAS_PRO_STATUS = [
  {
    id: null,
    value: <FormattedMessage id='community.status.all' />,
  },
  {
    id: 1,
    value: <FormattedMessage id='community.status.isPro' />,
  },
  {
    id: 0,
    value: <FormattedMessage id='community.status.noPro' />,
  },
]

export const FILTER_CONFIG = [
  {
    key: 'status',
    label: 'community.status.selectCommunityStatus',
    options: COMMUNITY_HAS_PRO_STATUS,
    type: 'select',
  },
]
